// extracted by mini-css-extract-plugin
export default {"popup__title":"mediaDevicesErrorPopup_popup__title__Y8IL+","popup__img":"mediaDevicesErrorPopup_popup__img__uQm39","popup__text":"mediaDevicesErrorPopup_popup__text__1IBS+"};